/* istanbul ignore file */
import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import EmptyNotificationTemplateMessage from './EmptyNotificationTemplatesMessage/EmptyNotificationTemplateMessage';
import NotificationTemplateListTable from './NotificationTemplateListTable/NotificationTemplateListTable';
import { RaaRoles } from '../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
import {
  selectNotificationTemplates,
  selectNotificationTemplatesCrudStatus,
} from '../../../../redux/slices/notificationTemplatesSlice/notificationTemplatesSlice';

function NotificationTemplateListLayout() {
  const history = useHistory();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const { activeTierHasAdvancedAlerting } = activeSubscription;
  const crudStatus = useSelector(selectNotificationTemplatesCrudStatus);

  const notificationTemplateList = useSelector(selectNotificationTemplates);

  return (
    <>
      <div className="row">
        <div className="col">
          <h2 className="mb-0">
            Notification Templates
          </h2>
        </div>
        <div className="col text-right">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/s/actions/notification-templates/new')}
            >
              New Template
            </button>
          </HasRolePrivileges>
        </div>
      </div>
      <hr className="my-4" />
      <div>
        {notificationTemplateList.length === 0 && crudStatus !== CrudStatus.PENDING ? (
          <EmptyNotificationTemplateMessage />
        )
          : (
            <NotificationTemplateListTable />
          )}
        {
            // using advanced alerting to check if subscription tier is lower than professional
              !activeTierHasAdvancedAlerting && (
              <div className="alert alert-info rounded my-1">
                <span>
                  <Icon icon="info-circle" />
                  {' '}
                </span>
                {' '}
                {/* eslint-disable-next-line max-len */}
                Your current account level does not include access to this feature. For advanced functionality including alerts that support multiple actions, repeat notifications, customized notification templates and more, consider
                {' '}
                <a href="/s/subscription/billing/change-plan">upgrading your account.</a>
              </div>
              )
          }
      </div>
    </>
  );
}

export default NotificationTemplateListLayout;
